import { useMemo } from "react";
import type { StripeAddressElementOptions } from "@stripe/stripe-js";

export const useAddressElementFields = () =>
  useMemo<StripeAddressElementOptions["fields"]>(
    () => ({
      // We never require the phone field.
      phone: "never",
    }),
    [],
  );
